import getMuiListItem from './MuiListItem';
import getMuiList from './MuiList';
import getMuiDialog from './MuiDialog';
import getMuiAccordion from './MuiAccordion';
import getMuiBreadcrumbs from './MuiBreadcrumbs';
import getMuiSwitch from './MuiSwitch';
import getMuiButton from './MuiButton';
import getMuiButtonBase from './MuiButtonBase';
import getSelectMenuTopSearch from './SelectMenuTopSearch';
import getMuiIconButton from './MuiIconButton';
import getMuiCard from './MuiCard';
import getMuiFormControlLabel from './MuiFormControlLabel';
import getMuiInputBase from './MuiInputBase';
import getMuiBadge from './MuiBadge';
import getMuiCheckbox from './MuiCheckbox';
import getMuiChip from './MuiChip';
import getMuiInputLabel from './MuiInputLabel';
import getMuiLink from './MuiLink';
import getMuiMenu from './MuiMenu';
import getMuiMenuItem from './MuiMenuItem';
import getMuiOutlinedInput from './MuiOutlinedInput';
import getMuiTooltip from './MuiTooltip';
import getMuiTab from './MuiTab';
import getMuiTabs from './MuiTabs';
import getTextField from './TextField';
import getMuiSelect from './MuiSelect';
import getMuiFormControl from './MuiFormControl';
import getMuiContainer from './MuiContainer';
import getMuiAutocomplete from './MuiAutocomplete';

const components = {
  MuiAutocomplete: getMuiAutocomplete(),
  MuiBadge: getMuiBadge(),
  MuiBreadcrumbs: getMuiBreadcrumbs(),
  MuiButton: getMuiButton(),
  MuiButtonBase: getMuiButtonBase(),
  MuiCard: getMuiCard(),
  MuiCheckbox: getMuiCheckbox(),
  MuiChip: getMuiChip(),
  MuiContainer: getMuiContainer(),
  MuiFormControl: getMuiFormControl(),
  MuiFormControlLabel: getMuiFormControlLabel(),
  MuiIconButton: getMuiIconButton(),
  MuiInputBase: getMuiInputBase(),
  MuiInputLabel: getMuiInputLabel(),
  MuiLink: getMuiLink(),
  MuiList: getMuiList(),
  MuiListItem: getMuiListItem(),
  MuiMenu: getMuiMenu(),
  MuiMenuItem: getMuiMenuItem(),
  MuiOutlinedInput: getMuiOutlinedInput(),
  MuiSelect: getMuiSelect(),
  MuiSwitch: getMuiSwitch(),
  MuiTab: getMuiTab(),
  MuiTabs: getMuiTabs(),
  MuiTooltip: getMuiTooltip(),
  SelectMenuTopSearch: getSelectMenuTopSearch(),
  TextField: getTextField(),
  MuiDialog: getMuiDialog(),
  MuiAccordion: getMuiAccordion(),
};
export default components;
